import { AxiosResponse, AxiosError } from 'axios';
import { isObject, merge } from 'lodash';
import moment from 'moment';
import { BackgroundColor, Customization, Trktype } from 'types';
import { RawItem } from 'types/api';
import uuid from 'uuid/v4';

export * from './cypress';
export { default as api } from './api';

export const buildGradient = (backgroundColor: BackgroundColor) => {
  const { Degree, ColorA, ColorAStart, ColorB, ColorBStart } = backgroundColor;
  return `linear-gradient(${Degree}deg, ${ColorA} ${ColorAStart}%, ${ColorB} ${ColorBStart}%)`;
};

export const customize = <T extends RawItem>(entities: T[], customizations?: Customization[]) =>
  !customizations
    ? entities
    : entities.map(entity => {
        const custom = customizations.find(item => entity.id === item.product2Id);
        return custom ? merge({ ...entity }, custom) : entity;
      });

export const customizeByLineItemId = <T extends { lineItemId?: string }>(
  entities: Record<string, T>,
  customizations?: Customization[],
) =>
  !customizations
    ? Object.keys(entities).map(key => entities[key])
    : Object.keys(entities).map(key => {
        const custom = customizations.find(item => entities[key].lineItemId === item.lineItemId);
        return custom ? (merge(entities[key], custom) as T) : entities[key];
      });

export const defaultReviewObject = {
  rating: 3,
  user_ratings_total: 0,
} as const;

export const generateCookiesSettings = () => ({
  id: uuid(),
  options: {
    domain: window.location.hostname === 'localhost' ? '' : '.mymoria.de',
    expires: moment().add(6, 'month').toDate(),
    path: '/',
  },
});

export const getAxiosData = <T>({ data }: AxiosResponse<T>) => data;

export const getLastURLPath = (path: string) => {
  const parts = path.split('/');

  return parts[parts.length - 1];
};

export const isAxiosError = (e: any): e is AxiosError => {
  return e.isAxiosError === true && e.response;
};

//TODO: Fix
export const parseDataLayerError = ({ response }: any) => ({
  endpoint: `${response?.config?.method?.toUpperCase()} ${response?.config?.url}`,
  params: Object.entries(response?.config?.params || {}).reduce(
    (acc, [key, value]) => acc.concat(`${key}: ${value};`),
    '',
  ),
  response: `${response?.data?.statusCode} ${response?.data?.code} ${response?.data?.message}`,
});

export const prepareTrackingDataParams = (
  trktype: Trktype,
  cat: string,
  act: string,
  lab: string,
) => ({
  'data-ctc-act': act,
  'data-ctc-cat': cat,
  'data-ctc-lab': lab,
  'data-ctc-trktype': trktype,
});

export const sleep = (ms: number = 5000) => new Promise(res => setTimeout(res, ms));

// @ts-ignore
export const sprintf = (template, params) => {
  if (!isObject(params) || !template) {
    return template;
  }

  let output = template;
  Object.keys(params).forEach(p => {
    // @ts-ignore
    output = output.replace(new RegExp(`%\\(${p}\\)`, 'g'), params[p]);
  });
  return output;
};
